import React from "react";
import { Facebook, Instagram, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="209325" id="footer" className="dark bg-background text-foreground py-12 border-t border-border/10 relative">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col items-center gap-8">
        <div className="flex flex-col md:flex-row items-center justify-between w-full gap-6">
          <Link to="/">
            
          </Link>

          <div className="flex items-center gap-3">
            <Button variant="ghost" size="icon" className="rounded-full hover:bg-primary/10 text-muted-foreground hover:text-primary transition-colors" asChild>
              <Link to="https://www.facebook.com/sinigorostouenstolou" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </Link>
            </Button>
            <Button variant="ghost" size="icon" className="rounded-full hover:bg-primary/10 text-muted-foreground hover:text-primary transition-colors" asChild>
              <Link to="https://www.instagram.com/militaryconsultantofficial?igsh=cmt0dHlqMGVtbDNs" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </Link>
            </Button>
          </div>
        </div>

        <div className="w-full h-px bg-border/20" />

        <div className="text-center text-sm font-default text-muted-foreground">
          <p>© 2026&nbsp;Ο Συνήγορος του ένστολου Με την επιφύλαξη παντός δικαιώματος.</p>
        </div>
      </div>

      {}
      <Button asChild className="md:hidden fixed bottom-6 right-6 z-50 size-14 rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/40 hover:bg-primary/90 transition-transform hover:scale-105 flex items-center justify-center p-0 animate-pulse">
        <Link to="tel:6987318178" aria-label="Άμεση Κλήση">
          <Phone className="w-6 h-6" />
        </Link>
      </Button>
    </section>;
}